/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { UserProfileDropdown } from "./dropdowns/UserProfileDropdown";
import * as actions from "../../../../app/modules/Auth/_redux/AuthAction";

export function QuickUserToggler() {
  const dispatch = useDispatch();
  const { user, authToken } = useSelector(
    (state) => ({
      user: state.auth.user,
      authToken: state.auth.authToken,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getUserByToken(authToken));
  }, [authToken]);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  return (
    <>
      <div className="topbar-item">
        <div
          className="w-auto btn-clean d-flex align-items-center btn-lg px-2"
          id="kt_quick_user_toggle"
        >
          <>
            <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
              歡迎回來,
            </span>
            <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
              {user ? user.displayName : null}
            </span>
          </>
        </div>
      </div>

      {!layoutProps.offcanvas && <UserProfileDropdown />}
    </>
  );
}
